export default __webpack_public_path__ + "static/media/pw.a831460a.svg";